import {UserDao} from '../../dao';
import {ErrorModel} from '../../models';
import { UserModel } from '../../models/user';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'GET_USER_DETAILS';

export async function getUserDetails(userToken: string) {
    try {
        const result = await UserDao.getUserDetails(userToken);

        const parsedResult = UserModel.parseUser(result);

        return parsedResult;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récuperation des détails d\'un utilisateur.',
            error: error
        });
    }
}
